<div class="ss" [class.is-open]="open()">
  <button type="button" class="ss__trigger" (click)="toggle()" [disabled]="disabled()"
          [attr.aria-expanded]="open()" aria-haspopup="listbox">
    @if (icon()) {
      <i class="ss__lead" [class]="icon()" aria-hidden="true"></i>
    }
    <span class="ss__value" [class.is-placeholder]="!selectedLabel()">
      {{ selectedLabel() || placeholder() }}
    </span>
    <i class="fa-solid fa-chevron-down ss__chev" aria-hidden="true"></i>
  </button>

  @if (open()) {
    <div class="ss__panel" role="listbox">
      <div class="ss__search">
        <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
        <input type="text" [ngModel]="search()" (ngModelChange)="search.set($event)"
               [placeholder]="'FORMS.SEARCH' | translate"
               [attr.aria-label]="'FORMS.SEARCH' | translate" autocomplete="off">
      </div>
      <ul class="ss__list">
        @if (showAll()) {
          <li>
            <button type="button" class="ss__option ss__option--all"
                    [class.is-selected]="value() === null"
                    role="option" [attr.aria-selected]="value() === null" (click)="selectAll()">
              <span>{{ allLabel() }}</span>
              @if (value() === null) {
                <i class="fa-solid fa-check" aria-hidden="true"></i>
              }
            </button>
          </li>
        }
        @for (o of filtered(); track o.id) {
          <li>
            <button type="button" class="ss__option" [class.is-selected]="o.id === value()"
                    role="option" [attr.aria-selected]="o.id === value()" (click)="select(o)">
              <span>{{ o.label }}</span>
              @if (o.id === value()) {
                <i class="fa-solid fa-check" aria-hidden="true"></i>
              }
            </button>
          </li>
        }
        @if (filtered().length === 0 && !showAll()) {
          <li class="ss__empty">{{ 'FORMS.NO_RESULTS' | translate }}</li>
        }
      </ul>
    </div>
  }
</div>
